import React from "react";
import OffRoad from "./OffRoad";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const MobileOffRoad = () => {
  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Mobile Combustion">
        <OffRoad />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default MobileOffRoad;
